export const sitesWebMisc = {
  // NombreEditable.vue — campo del nombre de la web, editable en línea
  ne: {
    aria: "Nombre de tu web",
    placeholder: "Mi alojamiento",
    hint: "Intro para guardar · Esc para dejarlo como estaba",
  },

  // website/index.vue — asistente de creación de la web
  website: {
    next: "Siguiente",
  },

  // Notificaciones/index.vue — línea de tiempo de notificaciones
  notif: {
    title: "Notificaciones",
    subtitle: "Todo lo que ha pasado en tus alojamientos, en orden cronológico.",
    // Filtros
    filterAll: "Todas",
    filterBookings: "Reservas",
    filterCheckins: "Check-ins",
    filterServices: "Servicios",
    filterPayments: "Pagos",
    // Estado vacío
    emptyAll: "Aún no hay notificaciones",
    emptyFilter: "Sin notificaciones en este filtro",
    emptyBody:
      "Cuando ocurra algo en tus reservas —una nueva, un check-in, un pago— aparecerá aquí.",
    // Separadores de día
    noDate: "Sin fecha",
    today: "Hoy",
    yesterday: "Ayer",
    // Estado del evento (columna izquierda)
    stNueva: "Nueva",
    stActualizada: "Actualizada",
    stCancelada: "Cancelada",
    stRealizado: "Realizado",
    stSolicitado: "Solicitado",
    stRecibida: "Recibida",
    stAprobada: "Aprobada",
    stRechazada: "Rechazada",
    stConfirmado: "Confirmado",
    stEnProceso: "En proceso de pago",
    stAviso: "Aviso",
    // Categoría del evento (subtítulo)
    catReserva: "reserva",
    catCheckin: "check-in",
    catServicio: "servicio",
    catSolicitud: "solicitud",
    catPago: "pago",
    catPagoPendiente: "pago pendiente",
    catSistema: "sistema",
    // Etiquetas descriptivas del tipo de evento
    lbNuevaReserva: "Nueva reserva",
    lbReservaActualizada: "Reserva actualizada",
    lbReservaCancelada: "Reserva cancelada",
    lbCheckin: "Check-in",
    lbServicio: "Servicio",
    lbSolicitud: "Solicitud",
    lbSolicitudAprobada: "Solicitud aprobada",
    lbSolicitudRechazada: "Solicitud rechazada",
    lbPago: "Pago",
    lbNotificacion: "Notificación",
  },

  // Integrations/index.vue — integraciones con servicios externos
  integrations: {
    title: "Integraciones",
    subtitle: "Conecta servicios externos para optimizar la gestión",
    descPricelabs: "Optimización dinámica de precios",
    descStripe: "Cobros a huéspedes con tarjeta",
    descWompi: "Cobros a huéspedes en Colombia",
    connected: "Conectado",
    disconnected: "No conectado",
  },
};
